import React, { ButtonHTMLAttributes, PropsWithChildren } from 'react';

import LoadingSpinner from 'components/loading-spinner';
import { Button } from './components';
import theme from 'utils/theme';

type ButtonPrimaryProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'disabled'
> & {
  backgroundColor?: string;
  disabled?: boolean;
  isLoading?: boolean;
  small?: boolean;
};

const ButtonPrimary = ({
  backgroundColor,
  disabled,
  isLoading,
  children,
  small,
  ...props
}: PropsWithChildren<ButtonPrimaryProps>) => {
  return (
    <Button
      backgroundColor={backgroundColor}
      disabled={disabled || isLoading}
      {...props}>
      {children}
      {isLoading && <LoadingSpinner size={24} marginLeft={10} color={theme.colors.blue2[40]} />}
    </Button>
  );
};

export default ButtonPrimary;
